const buttonEquipStatusInput = {
  text: '	Enviar'
};

export default buttonEquipStatusInput;
